import { render, staticRenderFns } from "./SettingSaleDiscountsPopup.vue?vue&type=template&id=6a3436f6&scoped=true&"
import script from "./SettingSaleDiscountsPopup.vue?vue&type=script&lang=js&"
export * from "./SettingSaleDiscountsPopup.vue?vue&type=script&lang=js&"
import style0 from "./SettingSaleDiscountsPopup.vue?vue&type=style&index=0&id=6a3436f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3436f6",
  null
  
)

export default component.exports